module.exports = __webpack_public_path__ + "img/gle-coupe.afea3a7e.jpg";